import { Statistic as AntdStatistic, Flex } from 'antd';
import cx from 'clsx';
import React from 'react';
import Skeleton from '../skeleton';
import styles from './index.module.scss';

const Statistic = (props) => {
  const {
    title = '',
    value = '',
    valuePrefix = '',
    loading = false,
    className = '',
    valueColor = null,
    valueStyles = {},
    suffix,
    formatter,
    style = {},
  } = props;

  const valueStyle = {
    color: valueColor,
    ...valueStyles,
  };

  if (loading) {
    return (
      <Flex gap={4} vertical style={{ alignItems: 'center' }}>
        <Skeleton height={20} width={70} />
        <Skeleton height={20} width={90} />
      </Flex>
    );
  }

  return (
    <AntdStatistic
      title={title}
      prefix={valuePrefix}
      value={value?.toLocaleString()}
      rootClassName={cx(styles.valueBlock, className)}
      valueStyle={valueStyle}
      suffix={suffix}
      formatter={formatter}
      style={style}
    />
  );
};

export default Statistic;
